import { useFetch } from 'app/queryProvider';
import { TTeleassistanceRequest } from 'app/_modules/pathways';
import { useAuth } from 'app/auth/hooks/useAuth';

interface IAppointmentsResponse {
  results: TTeleassistanceRequest[];
}

export const useTeleassistanceRequests = () => {
  const { meData } = useAuth();
  const pathwayId = meData?.current_pathway?.id;

  const { data, isFetching, refetch } = useFetch<IAppointmentsResponse>({
    queryKey: [['appointments', pathwayId as string]],
    url: '?source=patient&modality=teleassistance',
    resource: { name: 'appointments' },
    options: {
      enabled: !!pathwayId,
    },
  });

  return {
    requests: data?.results ?? [],
    isFetching,
    refetch,
  };
};
